class AnalyticsHelper {
  amplitudePageView() {
    let amplitudeInitAttempts = 0;
    const maxAmplitudeInitAttempts = 10;

    function waitForAmplitudeInit() {
      if (typeof amplitude !== 'undefined') {
        try {
          amplitude.setUserId(USER_FP);
          amplitude.logEvent('PageViewEvent', {
            location: window.location.href,
          });
        } catch (error) {
          console.info('Error initializing Amplitude:', error);
        }
      } else if (amplitudeInitAttempts < maxAmplitudeInitAttempts) {
        amplitudeInitAttempts++;
        setTimeout(waitForAmplitudeInit, 250);
      }
    }

    waitForAmplitudeInit();
  }

  clarityPageView() {
    let clarityInitAttempts = 0;
    const maxClarityInitAttempts = 10;

    function waitForClarityInit() {
      if (typeof window.clarity === 'function') {
        try {
          window.clarity('identify', USER_FP);
        } catch (error) {
          console.info('Error initializing Clarity:', error);
        }
      } else if (clarityInitAttempts < maxClarityInitAttempts) {
        clarityInitAttempts++;
        setTimeout(waitForClarityInit, 250);
      }
    }
    waitForClarityInit();
  }

  formSubmitEvent(formLabel) {
    if (typeof amplitude !== 'undefined') {
      amplitude.logEvent('Form submitted', {
        form_label: formLabel,
      });
    }

    if (typeof window.clarity === 'function') {
      window.clarity('event', `${formLabel} submitted`);
    }
  }
}

export default new AnalyticsHelper();
